/**
 * All breakpoints targeting types
 */
var breakpointsUpToTargets = ['upToXs', 'upToSm', 'upToMd', 'upToLg', 'upToXl', 'upToXxl'];
var breakpointsFromTargets = ['fromXs', 'fromSm', 'fromMd', 'fromLg', 'fromXl', 'fromXxl'];
var breakpointsOnTargets = ['onXs', 'onSm', 'onMd', 'onLg', 'onXl', 'onXxl'];
var breakpointsTargets = [].concat(breakpointsUpToTargets, breakpointsFromTargets, breakpointsOnTargets);

/**
 * Mapping for all breakpoints width
 */
var BREAKPOINTS_WIDTH_MAP = {
  xs: 1,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
/**
 * Mapping to specify breakpoint limits and enable "on" targeting
 */

var NEXT_BREAKPOINT_MAP = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl',
  xl: 'xxl',
  xxl: null
};
/**
 * All breakpoints keys
 */

var BREAKPOINTS_KEYS = Object.keys(BREAKPOINTS_WIDTH_MAP);
/**
 * All base media queries that will be applied to Stitches
 * These media queries are generated from the width map using the "min-width" rule
 *
 * e.g: `md: (min-width: 768px)`
 */

var BREAKPOINTS_MEDIAS = Object.keys(BREAKPOINTS_WIDTH_MAP).reduce(function (acc, breakpoint) {
  acc[breakpoint] = "(min-width: ".concat(BREAKPOINTS_WIDTH_MAP[breakpoint], "px)");
  return acc;
}, {});
/**
 * Helper to generate "on" media-queries
 */

var medias = {
  on: function on(breakpoint) {
    if (!BREAKPOINTS_WIDTH_MAP[breakpoint]) {
      return '';
    }

    var nextBreakpoint = NEXT_BREAKPOINT_MAP[breakpoint];

    if (!nextBreakpoint) {
      return BREAKPOINTS_MEDIAS.xxl;
    }

    return "".concat(BREAKPOINTS_MEDIAS[breakpoint], " and (max-width: ").concat(BREAKPOINTS_WIDTH_MAP[nextBreakpoint] - 1, "px)");
  }
};
export { breakpointsTargets, BREAKPOINTS_KEYS, BREAKPOINTS_MEDIAS, BREAKPOINTS_WIDTH_MAP, medias, NEXT_BREAKPOINT_MAP };